'use client'

import { with_comma } from "@/util/comma";
import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import ParsedHtmlContent from "../etc/renderContent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import CommentList from "./coment";
import { addViewCountTypes, BoardViewTypes } from "@/type/list";
import EditView from "./edit";
import { AuthContext } from "@/context/authContext";
import { editPageTypes } from "@/type/edit";
import React from "react";
import default_image from "@/public/icon/default_user.svg"
import api from "@/util/api";
import ComentWrite from "./coment_write";
import { DeviceContext } from "@/context/deviceContext";
import { usePathname } from "next/navigation";
import customAlert from "@/util/customAlert";
import { useTranslations } from "next-intl";

interface ViewProps extends React.HTMLAttributes<HTMLDivElement> {
    selectContent: any
    setSelectContent: Function
    fetchData: () => void
    post: string
    writeAuth: boolean
    editAuth: boolean
    editPage?: editPageTypes
    editCategory?: number
}

const BoardView = React.forwardRef<HTMLDivElement, ViewProps>(
     (props, ref) => {

        const {
            selectContent,
            setSelectContent,
            fetchData,
            post,
            writeAuth = false,
            editAuth = false,
            editPage = 'defualt',
            editCategory
        } = props;


        const { mobileMode } = useContext(DeviceContext);
        const [editView, setEditView] = useState<boolean>(false)
        const [editContent, setEditContent] = useState<any>()
        const viewRef = useRef<HTMLDivElement>(null)
        const recomRef = useRef<HTMLButtonElement>(null)
        const { user } = useContext(AuthContext)
        const [scrollTop, setScrollTop] = useState<boolean>(false)

        const t = useTranslations("Text")
        const a = useTranslations("Sentence")

        function scrollTopSmooth() {
            // if (mobileMode)
            if(viewRef.current?.offsetTop)
                window.scrollTo({ top: viewRef.current.offsetTop - 90, behavior: 'instant' });
        }

        const path = usePathname()

        function clickLike(id:number){
            if( !user.is_authenticated ){
                customAlert(a("NeedLogin"), "warning")
                return
            }
            api(`/api/community/like/${id}/`,{method:"POST"})
                .then((res) => res.json())
                .then(({ data }) => {

                    if (!recomRef.current) return;
                    const span = recomRef.current.querySelector('span');
                    if (span) span.textContent = String(data.liked_count);
                    recomRef.current.classList.toggle('active', !!data.is_liked);

                    
                })
                .catch(err => {
                    console.error('errrrrr', err);
                });

        }

        function setfetchData() {
            const cleanUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, '', cleanUrl);
            setEditView(false)

            if (typeof fetchData === 'function') fetchData();
        }
        function deleteContent() {
            const formData = new FormData()
            if (!selectContent.id) {
                customAlert(a("WrongContents"), 'warning')
                return;
            }

            formData.set('id', selectContent.id)
            formData.set('cate', String(editCategory))

            api(post + "delete/", { method: 'POST', body: formData })
                .then(res => res.json())
                .then(({ data, status, status_code, message }) => {
                    customAlert(message, status)
// console.log(data)
                    setfetchData()
                })
                .catch((error: Response) => {
                    customAlert(a("ErrorRequest"), 'error')
                })
        }

        useEffect(()=> {
            window.scrollTo(0, 0)
            setEditView(false)

            if(!selectContent){
                window.scrollTo(0, 0)
            }
        }, [path, selectContent])

        useEffect(() => {
            if (selectContent) {
                setEditView(false);
                scrollTopSmooth()
                const timeout = setTimeout(() => {

                }, 10);
                return () => clearTimeout(timeout); // cleanup
            }
        }, [path, selectContent]);

        useEffect(() => {
            if (editView) {
                // setSelectContent(undefined)
                scrollTopSmooth()
            }
        }, [editView])

        return (
            <>
            <div className="board-view" ref={ref}>
                <div className="board-view" ref={viewRef}>
                    {
                        editView ?
                            <EditView post={post}
                                editContent={editContent}
                                setSelectContent={setSelectContent}
                                setEditView={setEditView}
                                fetchData={fetchData}
                                editPage={editPage as editPageTypes} />
                            :

                            selectContent &&
                            <>
                                <div className="view-title">
                                    <header >
                                        <div className="title">{selectContent.title}</div>
                                        <div className="author">
                                            <div className="profile-image">
                                                <img src={default_image.src} alt="" />
                                            </div>
                                            <div className="info">
                                                <div className="other">
                                                    <div className="nickname">{selectContent.author_name}</div>
                                                    <span>{moment(selectContent.create_dt).format('MM-DD HH:mm')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </header>
                                </div>
                                <main style={{ overflowWrap: "break-word" }}>
                                    <ParsedHtmlContent html={selectContent?.content ?? ""} />
                                </main>
                                <div className="btns">
                                    <div className={`w-100-per flex center m-b-10`}>
                                        {selectContent.is_author && user.is_authenticated &&
                                            <>
                                                <button className={`editBtn`}
                                                    onClick={e => {
                                                        setEditContent(selectContent)
                                                        setEditView(true)
                                                    }}>{t("수정")}</button>
                                                <button className={`deleteBtn`} onClick={deleteContent}>{t("삭제")}</button>
                                            </>
                                        }
                                    </div>
                                    <div>
                                        <button className={`recomBtn ${selectContent.is_liked ? 'active' : ''}`}
                                            onClick={() => { clickLike(selectContent.id) }}
                                            ref={recomRef}>
                                            <FontAwesomeIcon icon={faThumbsUp} />
                                            <span>{selectContent.like_count || 0}</span>
                                        </button>
                                        <button className={`listBtn`} onClick={e => {
                                            setSelectContent(undefined)
                                            window.scrollTo({ top: 0, behavior: "smooth" })
                                        }}>{t("목록")}</button>
                                    </div>
                                </div>
                                <ComentWrite board_id={selectContent.id} fetchData={fetchData} post={post} />
                                <CommentList comments={selectContent.comments} post={post} />
                            </>
                    }
                </div>
            </div>
            </>
        )
    }
)

BoardView.displayName = 'BoardView'
export default BoardView;